// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c434b7a2","455":"a75c28e9","946":"9c01c061"}[chunkId] + ".chunk.js";
};